import React from "react";

function ResetButton({ onReset }) {
  const handleReset = async () => {
    if (!window.confirm("Ar tikrai norite ištrinti visus užsakymus?")) return;
    try {
      const res = await fetch("https://worker.kebatic.org/reset", { method: "POST" });
      if (res.ok) {
        alert("Užsakymai išvalyti!");
        if (onReset) onReset();
      } else {
        alert("Nepavyko išvalyti: " + await res.text());
      }
    } catch (err) {
      alert("Klaida jungiantis prie serverio.");
    }
  };

  return (
    <button
      className="btn-reset"
      data-i18n="reset_btn"
      type="button"
      onClick={handleReset}
    >
      Išvalyti visus užsakymus
    </button>
  );
}

export default ResetButton;
